import { render, staticRenderFns } from "./FooterUpperSection.vue?vue&type=template&id=719f0f88"
import script from "./FooterUpperSection.vue?vue&type=script&lang=ts"
export * from "./FooterUpperSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports